import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "../../Styles/Generalinfo.module.scss";
//import infoSeptember from "../../img/Israel/General_Information_Sept_2026.pdf";
//import infoSeptember from "../../img/Israel/General_Information_September_2026.pdf";
//import infoOctober from "../../img/Israel/General_Information_Oct_2026.pdf";

function Generalinfo() {
  const insurance = {
    href: "https://www.travelguard.com/",
    target: "_blank"
  };
  const IsraelPermit = {
    href: "https://israel-entry.piba.gov.il",
    target: "_blank"
  };

  const params = useParams();

  let dates = "";
  let cost = [];
  let groupSize = "";
  let servicesIncluded = [];
  let servicesExcluded = [];

  const costSeptember = [
    "$2,665 plus airfare (double occupancy)",
    "Supplement trip adds $900"
  ];
  const costOctober = [
    "$3,800 plus airfare (double occupancy)",
    "Supplement for single room: US$ 1,178. Reduction for 3rd person in a triple room: US$ 90"
  ];
  const costNovember = [
    "$2,625 plus airfare (double occupancy)",
    "Supplement trip adds $900"
  ];
  const costJune = [
    "$3,500 plus airfare (double occupancy)",
    "Supplement for single room: US$ 1,164. Reduction for 3rd person in a triple room: US$ 90"
  ];

  const servicesIncludedSeptember = [
    "Transportation in country",
    "Accommodation for 10 nights on B&B basis. Thirteen nights if the supplement trip is included.",
    "Dinner is included when staying the one night at the Dead Sea.",
    "Entry costs to all sites and activities listed in the itinerary",
    "Biblical study tour guide and teaching: Dr. Dan Glick",
    "Access to all pre and post trip materials (see below)",
    "Audio headsets"
  ];
  const servicesIncludedOctober = [
    "Transportation in country (late model air-conditioned bus)",
    "Accommodation for 9 nights on half board basis. Hotel quality is 3.5-4.5 stars.",
    "Breakfast and dinner included at all hotels",
    "Entry costs to all sites and activities listed in the itinerary",
    "All gratuities for guide, driver, hotels and restaurants staff",
    "Biblical study tour guide and teaching: Dr. Dan Glick and Pastor John Kirby",
    "Licensed English-speaking Israeli guide",
    "Access to all pre and post trip materials (see below)",
    "Audio headsets"
  ];
  const servicesIncludedJune = [
    "Transportation in country (late model air-conditioned bus)",
    "Accommodation for 9 nights. Hotel quality is 3.5-4.5 stars.",
    "Breakfast and dinner included at all hotels",
    "Entry costs to all sites and activities listed in the itinerary",
    "All gratuities for guide, driver, hotels and restaurants staff",
    "Biblical study tour guide and teaching: Dr. Dan Glick",
    "Licensed English-speaking Israeli guide",
    "Access to all pre and post trip materials (see below)",
    "Audio headsets"
  ];
  const servicesExcludedSeptember = [
    "Airfare",
    "Lunches and most dinners: some tour groups bring healthy snacks to eat throughout the day vs stopping for lunches.",
    "Medical, traveler’s or personal insurance.",
    "Personal expenses",
    "Passport and ETA-IL entry permit (see Travel Documents below to know how to secure this.)"
  ];
  const servicesExcludedOctober = [
    "Airfare",
    "Lunches of $20-$25 avg. per person per meal (Some tour groups bring healthy snacks to eat throughout the day vs stopping for lunches. Breakfast & dinner are usually very large meals",
    "Medical, traveler’s or personal insurance",
    "Personal expenses",
    "Passport and ETA-IL entry permit (see Travel Documents below to know how to secure this.)"
  ];
  const servicesExcludedJune = [
    "Airfare",
    "Lunches of $20-$25 avg. per person per meal (Some tour groups bring healthy snacks to eat throughout the day vs stopping for lunches. Breakfast & dinner are usually very large meals",
    "Medical, traveler’s or personal insurance",
    "Personal expenses",
    "Passport and ETA-IL entry permit (see Travel Documents below to know how to secure this.)"
  ];

  switch (params.trip) {
    case "September-2026":
      dates = "September 29 - October 10 (supplement until October 13), 2026";
      //info = infoSeptember;
      cost = costSeptember;
      groupSize = "12-16";
      servicesIncluded = servicesIncludedSeptember;
      servicesExcluded = servicesExcludedSeptember;
      break;
    case "October-2026":
      dates = "October 20 - 30, 2026";
      //info = infoOctober;
      cost = costOctober;
      groupSize = "26";
      servicesIncluded = servicesIncludedOctober;
      servicesExcluded = servicesExcludedOctober;

      break;
    case "November-2026":
      dates = "November 2 - 13 (supplement until November 16), 2026";
      //info = infoOctober;
      cost = costNovember;
      groupSize = "12 - 16";
      servicesIncluded = servicesIncludedSeptember;
      servicesExcluded = servicesExcludedSeptember;

      break;
    case "June-2027":
      dates = "May 24 - June 4, 2027";
      //info = infoOctober;
      cost = costJune;
      groupSize = "30";
      servicesIncluded = servicesIncludedJune;
      servicesExcluded = servicesExcludedJune;

      break;
    case "trip":
      dates = "TBA";
      //info = infoSeptember;
      cost = ["TBA"];
      groupSize = "14-28";
      servicesIncluded = servicesIncludedOctober;
      servicesExcluded = servicesExcludedOctober;

      break;
  }

  // useEffect(() => {
  //   if (params.trip === "trip") {
  //     console.log("yes");
  //     setJustTrip(true);
  //   } else {
  //     setJustTrip(false);
  //   }
  // }, []);

  return (
    <div className="pageContainer">
      <div className="title">General Information</div>
      <div className="printBox">
        {/* <div className="print">
          <a href={info} target="_blank" rel="noopener noreferrer">
            Print PDF
          </a>
        </div> */}
      </div>

      <div>
        <div className={styles.paragraphTitle}>TRIP DATES</div>
        <p className="text">{dates}</p>
      </div>

      <div>
        <div className={styles.paragraphTitle}>GROUP SIZE</div>
        <p className="text">{groupSize}</p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>COST</div>
        {cost.map((par) => (
          <p className={styles.list}>{par}</p>
        ))}
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesIncluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES NOT INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesExcluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DOCUMENTS</div>
        <p className="text">
          You will need a USA passport. Make sure your passport is valid and
          does not expire at least six months AFTER your re-entry date to the
          United States. You will also need an ETA-IL entry permit fee (to be
          applied for by travelers). For detailed information and to apply,
          please visit the Israel Entry Permit System
          <a {...IsraelPermit} rel="norferrer" className={styles.link}>
            israel-entry.piba.gov.il
          </a>
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>INSURANCE</div>
        <p className="text">
          [OPTIONAL] If you wish to purchase insurance for your trip, we
          recommend you use Travel Guard. There are many travel insurance
          companies out there, however, and one of them may prove to be a better
          option for you. You can visit
          <a {...insurance} rel="norferrer" className={styles.link}>
            TravelGuard.com
          </a>
          or call them at <span className={styles.highlight}>800-826-5248</span>
          . They have multiple options for insuring anything from the flight
          itself to the full cost of the trip. Most plans cover sickness,
          injury, or death of a family member.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          CANCELLATION AND REFUND POLICY
        </div>
        <p className="text">
          If you need to cancel your tour, you can do it, provided it is 120
          days before the tour date. After this, the trip is generally
          non-refundable due to contracts with hotels, guides, and
          transportation services.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>HOW TO SIGN UP FOR THE TRIP</div>
        <p className="text">
          Contact Dan Glick at{" "}
          <span className={styles.highlight}> danglick62@gmail.com</span> and
          provide your full passport name (exactly as it appears on your
          passport), date of birth, phone number, email address, and physical
          address. Then send in your deposit.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DEPOSIT</div>
        <p className="text">
          A $500 deposit is required to reserve your seat on this trip. Only a
          check is accepted as a form of payment. Checks should be made to{" "}
          <span style={{ textDecoration: "underline" }}>
            Tribe of Dan Tours
          </span>{" "}
          and mailed to Dan Glick, 9850 Cedar Cove, Alexandria, KY 41001.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PAYMENT POLICY</div>
        <p className="text">
          <span>The final payment will be due 120 days before departure.</span>{" "}
          Only a check is accepted as a form of payment. Checks should be made
          to Tribe of Dan Tours and mailed to Dan Glick, 9850 Cedar Cove,
          Alexandria, KY 41001.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          AUDIO TOUR GUIDE SOUND SYSTEM
        </div>
        <p className="text">
          Tribe of Dan Tours makes use of an audio tour guide sound receiver.
          With this receiver and the accompanying earbud, you will be able to
          hear your guide wherever you are in the group.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PRE-TRIP MATERIALS</div>
        <p className="text">
          Tribe of Dan Tours provides the following documents: 1) An itinerary
          2) A list of YouTube videos that one can watch about the country and
          sites of Israel. This is very helpful information prior to the trip,
          and Dan strongly encourages all tourists to take advantage of this and
          watch them in the months prior to the trip. 3) A Scripture reading
          guide. 4) A suggestive packing list. 5) A prayer guide. 6) Some travel
          advice. 7) A gallery of photos.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>POST-TRIP MATERIALS</div>
        <p className="text">
          Dan Glick has authored a 40-chapter book focusing on the biblical
          sites of Israel. This book will be presented as a gift to each
          traveler, serving as a valuable resource for recalling the sites
          explored. It encompasses a wealth of information provided at each
          location, along with insights into their spiritual and devotional
          significance. Each chapter features three photographs of the site and
          concludes with a prayer.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PHYSICAL REQUIREMENTS</div>
        <p className="text">
          There is substantial walking on this trip. It is recommended that you
          get a good amount of walking exercise in the weeks preceding the trip.
          There are no special vaccines required for entry into Israel.
        </p>
      </div>
    </div>
  );
}

export default Generalinfo;
